import QuestionResponseResource from "common/resources/Project/Config/Vote/QuestionResponseResource";
import { useCallback, useState } from "react";

export enum EVoteCardModal {
	CREATE = "CREATE",
	EDIT = "EDIT",
	DELETE = "DELETE",
}

export const useVoteCardModal = () => {
	const [openedModal, setOpenedModal] = useState<EVoteCardModal | null>(null);
	const [selectedVote, setSelectedVote] = useState<QuestionResponseResource | null>(null);

	const isModalOpen = useCallback((modal: EVoteCardModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
		setSelectedVote(null);
	}, []);

	const onOpenCreateModal = useCallback(() => {
		setOpenedModal(EVoteCardModal.CREATE);
	}, [setOpenedModal]);

	const onOpenEditModal = useCallback(
		(vote: QuestionResponseResource) => {
			setOpenedModal(EVoteCardModal.EDIT);
			setSelectedVote(vote);
		},
		[setOpenedModal],
	);

	const onOpenDeleteModal = useCallback(
		(vote: QuestionResponseResource) => {
			setOpenedModal(EVoteCardModal.DELETE);
			setSelectedVote(vote);
		},
		[setOpenedModal],
	);

	return { selectedVote, isModalOpen, onCloseModal, onOpenCreateModal, onOpenEditModal, onOpenDeleteModal };
};
